var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialaffairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.06 20.325C26.43 20.94 26.07 21.825 26.16 22.77C26.295 24.39 27.78 25.575 29.4 25.575H32.25V27.36C32.25 30.465 29.715 33 26.61 33H11.46C12.705 31.905 13.5 30.3 13.5 28.5C13.5 25.185 10.815 22.5 7.5 22.5C6.09 22.5 4.785 22.995 3.75 23.82V17.265C3.75 14.16 6.28499 11.625 9.38999 11.625H26.61C29.715 11.625 32.25 14.16 32.25 17.265V19.425H29.22C28.38 19.425 27.615 19.755 27.06 20.325Z",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.265V11.76C3.75 9.97502 4.84499 8.38496 6.50999 7.75496L18.42 3.25496C20.28 2.56496 22.275 3.93 22.275 5.925V11.625",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8382 20.9552V24.0453C33.8382 24.8703 33.1782 25.5453 32.3382 25.5753H29.3982C27.7782 25.5753 26.2932 24.3903 26.1582 22.7703C26.0682 21.8253 26.4282 20.9403 27.0582 20.3253C27.6132 19.7553 28.3782 19.4253 29.2182 19.4253H32.3382C33.1782 19.4553 33.8382 20.1302 33.8382 20.9552Z",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18H21",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28.5C13.5 30.3 12.705 31.905 11.46 33C10.395 33.93 9.015 34.5 7.5 34.5C4.185 34.5 1.5 31.815 1.5 28.5C1.5 26.61 2.37 24.915 3.75 23.82C4.785 22.995 6.09 22.5 7.5 22.5C10.815 22.5 13.5 25.185 13.5 28.5Z",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 26.625V28.875L6 30",
    stroke: "#265166",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialaffairs);
export default __webpack_public_path__ + "static/media/Financialaffairs.55f6c92db9e07cd4ef914bff95d60358.svg";
export { ForwardRef as ReactComponent };